module.exports = __webpack_public_path__ + "img/desktop/Menus-betmenu/btn-settings-up@2x.png?0.0.53";